import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { StatusBadge } from "@/components/StatusBadge";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Archive, Film, ExternalLink } from "lucide-react";

export default function ClientArchives() {
  const { t, ml } = useLang();
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    api.get("/archives").then((r) => setGroups(r.data)).catch(() => {});
  }, []);

  return (
    <div className="ch-fade-up space-y-8">
      <header>
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-neutral-400">{t("arch.eyebrow")}</p>
        <h1 className="mt-2 font-display text-4xl font-extrabold tracking-tight">{t("nav.archives")}</h1>
        <p className="mt-2 text-sm text-neutral-500">{t("arch.subtitle_client")}</p>
      </header>

      {groups.length === 0 && (
        <div className="flex flex-col items-center gap-3 rounded-sm border border-dashed border-neutral-200 py-16 text-neutral-400">
          <Archive className="h-8 w-8" strokeWidth={1.5} />
          <p className="text-sm">{t("arch.empty_client")}</p>
        </div>
      )}

      <Accordion type="multiple" className="space-y-3">
        {groups.map((g) => (
          <AccordionItem key={g.key} value={g.key} data-testid={`client-archive-group-${g.key}`} className="rounded-sm border border-neutral-200 px-5">
            <AccordionTrigger className="hover:no-underline">
              <div className="flex w-full items-center justify-between pr-4">
                <span className="font-display text-lg font-bold">{ml(g.month, g.year)}</span>
                <span className="text-sm font-normal text-neutral-500">{g.orders.length} {g.orders.length > 1 ? t("common.orders") : t("common.order")}</span>
              </div>
            </AccordionTrigger>
            <AccordionContent>
              <div className="space-y-3 pb-2">
                {g.orders.map((o) => (
                  <div key={o.id} className="rounded-sm border border-neutral-100 p-4">
                    <div className="flex items-center justify-between">
                      <p className="flex items-center gap-1.5 font-semibold"><Film className="h-3.5 w-3.5" />{o.package_name}</p>
                      <StatusBadge status={o.status} />
                    </div>
                    {o.videos.length > 0 && (
                      <div className="mt-3 space-y-1.5">
                        {o.videos.map((v, i) => (
                          <a key={i} href={v.url} target="_blank" rel="noreferrer" className="flex items-center gap-2 text-sm text-neutral-600 hover:text-black hover:underline">
                            <ExternalLink className="h-3.5 w-3.5 shrink-0" /><span className="truncate">{v.title || v.url}</span>
                          </a>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
